import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const deactivate: ISVGPersonalProps = {
  viewBox: '0 0 28 28',
  content: (
    <g id="deactive_icon" data-name="deactive icon" transform="translate(18459.691 2947.492)">
      <rect
        id="Rectangle_2788"
        data-name="Rectangle 2788"
        width="28"
        height="28"
        transform="translate(-18459.691 -2947.492)"
        fill="none"
      />
      <path
        id="Path_7211"
        data-name="Path 7211"
        d="M8.779,0a.881.881,0,0,0-.87.891V7.958a.88.88,0,1,0,1.76,0V.894A.881.881,0,0,0,8.8,0H8.779m5.127,1.771q-.043,0-.086,0a.884.884,0,0,0-.487,1.559,7.031,7.031,0,1,1-9.115.026.886.886,0,0,0,.1-1.245.876.876,0,0,0-1.239-.1A8.854,8.854,0,0,0,8.792,17.577,8.853,8.853,0,0,0,14.469,1.989.877.877,0,0,0,13.906,1.771Z"
        transform="translate(-18454.48 -2942.281)"
        fill="#79cdd0"
      />
    </g>
  ),
};
